
	function ContactForm(settings = {}){

		this.folder = settings.folder ?? "contact";

		this.data = {
			pages: [
				{
					name: "form",
					submissionUrl: settings.submissionUrl ?? "/forms/contact",
					onRender: $wrapper => {
						$wrapper.css("min-height",$wrapper.height()); //Set a min height to avoid a bit of jumpyness when changing page
					}
				},
				{
					name: "complete",
					labels: {
						thankyouMessage: settings.thankyouMessage ?? "Thanks for your message, we’ll get back to you as soon as we can."
					}
				}
			]
		}

		this.setup(settings);
	};
	ContactForm.inheritsFrom( PageForm );

